//action types
export const ADD_CONFIGURATION = 'ADD_CONFIGURATION';
export const VIEW_CONFIGURATION = 'VIEW_CONFIGURATION';

//add 
export function addConfiguration(data, callback) {
  return {
    type: ADD_CONFIGURATION,
    payload : {data, callback},
  };
}

//view 
export function viewConfiguration(data, callback) {
  return {
    type: VIEW_CONFIGURATION,
    payload : {data, callback},
  };
}


